import { MOBILE_OS } from '@src/constants/os';

export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return MOBILE_OS.WIN_PHONE;
  }

  if (/android/i.test(userAgent)) {
    return MOBILE_OS.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return MOBILE_OS.IOS;
  }

  return MOBILE_OS.UNKNOWN;
};
